import { render } from "./DocumentList.vue?vue&type=template&id=39523124&scoped=true&ts=true"
import script from "./DocumentList.vue?vue&type=script&lang=ts"
export * from "./DocumentList.vue?vue&type=script&lang=ts"

import "./DocumentList.vue?vue&type=style&index=0&id=39523124&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39523124"]])

export default __exports__